import React, { useState } from 'react';

import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';

import styles from './SettingsRedesign.module.scss';
import {
  SETTINGS_NAV_ITEMS,
  settingsNavKeys,
} from './SettingsRedesign.constants';
import { SettingsNavList } from './components/SettingsNavList.component';
import { HelpCard } from './components/HelpCard.component';
import { CompanySection } from './components/CompanySection.component';
import { TeamSettingsSection } from './components/TeamSettingsSection.component';
import { AppsAndUrlsSection } from './components/AppsAndUrlsSection.component';
import { ScreenshotsMonitoringSection } from './components/ScreenshotsMonitoringSection.component';
import { AlertsNotificationsSection } from './components/AlertsNotificationsSection.component';
import { LeaveAttendanceSection } from './components/LeaveAttendanceSection.component';
import { HolidaysSection } from './components/HolidaysSection.component';
import { PlaceholderSection } from './components/PlaceholderSection.component';

const BUILT_SECTIONS = {
  [settingsNavKeys.company]: CompanySection,
  [settingsNavKeys.teamSettings]: TeamSettingsSection,
  [settingsNavKeys.appsAndUrls]: AppsAndUrlsSection,
  [settingsNavKeys.screenshotsMonitoring]: ScreenshotsMonitoringSection,
  [settingsNavKeys.alertsNotifications]: AlertsNotificationsSection,
  [settingsNavKeys.leaveAttendance]: LeaveAttendanceSection,
  [settingsNavKeys.holidays]: HolidaysSection,
};

export const SettingsRedesignComponent = () => {
  const [activeNavKey, setActiveNavKey] = useState(settingsNavKeys.company);

  const activeNavItem = SETTINGS_NAV_ITEMS.find(
    (item) => item.key === activeNavKey
  );
  const ActiveSection = BUILT_SECTIONS[activeNavKey];

  return (
    <div className={styles.settingsPage}>
      <div className={styles.layout}>
        <div className={styles.navRail}>
          <div className={styles.navCard}>
            <Text
              variant={textVariantsEnum.Text_xxs}
              fontWeight={fontWeightEnum.Semibold}
              color="gray-500"
              className={styles.navCardLabel}
            >
              Settings
            </Text>
            <SettingsNavList
              items={SETTINGS_NAV_ITEMS}
              activeKey={activeNavKey}
              onSelect={setActiveNavKey}
            />
          </div>
          <HelpCard />
        </div>
        <div className={styles.detailPanel}>
          {ActiveSection ? (
            <ActiveSection onNavigate={setActiveNavKey} />
          ) : (
            <PlaceholderSection navItem={activeNavItem} />
          )}
        </div>
      </div>
    </div>
  );
};

SettingsRedesignComponent.displayName = 'SettingsRedesign';
